import { Pipe, PipeTransform } from '@angular/core';
import { UtilityCommon } from '../utils/utility-common';

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  transform(value: Array<any>, attrValueOrder: string, noOrder: boolean = false): any {
    if (noOrder){
      return value;
    }
    return UtilityCommon.orderBy(value, attrValueOrder);
  }
}
